import { rjPlugin, SUCCESS } from 'react-rocketjump'
import get from 'lodash/get'

export function adjustMulitpleMaterialiFilters(filters) {
  if (
    !Array.isArray(filters.materiali) ||
    !Array.isArray(filters.stati_materiali)
  ) {
    return filters
  }
  const deFilters = { ...filters }
  deFilters.materiali = deFilters.materiali.filter(
    (_, i) => (deFilters.stati_materiali ?? [])[i] !== '_'
  )
  deFilters.stati_materiali = deFilters.stati_materiali.filter(
    (v) => v !== '_'
  )
  return deFilters
}

export function getFasiNeededByOrder(order, fasiScheduler = []) {
  if (!order || !Array.isArray(fasiScheduler)) return {}

  const {
    produzione_interna,
    vetrazione_interna,
    reynaers,
    righe_ordine,
  } = order

  const hasTelai = (righe_ordine ?? []).some(
    (r) => r?.tipo_serramento?.telai
  )

  const isExternalProduction = !produzione_interna

  const result = {}

  for (const fase of fasiScheduler) {
    const nomeFase = fase?.nome_fase
    if (!nomeFase) continue

    // 1) Se vetrazione non interna, il vetro non serve

    // 2) Regole per REYNAERS
    if (reynaers) {
      // Se reynaers=true non servono queste fasi "standard"
      if (["macchine", "legno", "banchi", "verniciatura", "terzista_legno"].includes(nomeFase)) {
        result[nomeFase] = false
        continue
      }

      // Produzione esterna + reynaers: alcune fasi non servono
      if (
        isExternalProduction &&
        ["macchine_alluminio", "banchi_alluminio"].includes(
          nomeFase
        )
      ) {
        result[nomeFase] = false
        continue
      }

      // Caso speciale che nel tuo codice è esplicito: se esterno + reynaers,
      // terzista_alluminio deve essere true
      if (isExternalProduction && nomeFase === "terzista_alluminio") {
        result[nomeFase] = true
        continue
      }

      if(!isExternalProduction && ["terzista_alluminio"].includes(nomeFase)) {
        result[nomeFase] = false
        continue
      }
    }

    // 3) Regole per NON-REYNAERS
    if (!reynaers) {

      if(nomeFase === "terzista_alluminio") {
        result[nomeFase] = false
        continue
      }
      // Produzione esterna + non-reynaers: alcune fasi non servono
      if (
        isExternalProduction &&
        ["macchine", "terzista_alluminio", "legno"].includes(nomeFase)
      ) {
        result[nomeFase] = false
        continue
      }

      if(!isExternalProduction && ["terzista_legno"].includes(nomeFase)) {
        result[nomeFase] = false
        continue
      }

      // Nel tuo codice: esterno + non-reynaers => banchi true
      if (isExternalProduction && nomeFase === "banchi") {
        result[nomeFase] = true
        continue
      }

      // Se non reynaers non servono fasi alluminio/terzista alluminio
      if (["alluminio", "terzista_alluminio"].includes(nomeFase)) {
        result[nomeFase] = false
        continue
      }

      // E non servono nemmeno le fasi alluminio "dedicate"
      if (["macchine_alluminio", "banchi_alluminio"].includes(nomeFase)) {
        result[nomeFase] = false
        continue
      }
    }

    // 4) Default: tutto serve, tranne telai che dipende dalle righe ordine
    result[nomeFase] = nomeFase === "telai" ? hasTelai : true
  }
  console.log('getFasiNeededByOrder', order.id, result)
  return result
}


export function rjListWithTotals() {
  return rjPlugin({
    composeReducer: (prevState, { type, payload }) => {
      if (type === SUCCESS) {
        return {
          ...prevState,
          data: {
            ...prevState.data,
            totals: payload.data.totals,
          },
        }
      }
      return prevState
    },
    selectors: () => ({
      getTotals: (state) => get(state.root, 'data.totals', null),
    }),
  })
}
